<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  name: {
    type: String,
    default: '',
  },
  value: {
    type: [String, Number, Boolean],
    default: true,
  },
  label: {
    type: String,
    default: '',
  },
  size: {
    type: String as () => 'xs' | 'sm' | 'md' | 'lg',
    default: 'md',
  },
  color: {
    type: String,
    default: '#0E59FA',
  },
  labelColor: {
    type: String,
    default: '#0E59FA',
  },
})

const emit = defineEmits<(e: 'update:modelValue', value: boolean) => void>()

const sizeClasses = computed(() => {
  return {
    xs: {
      box: 'w-4 h-4',
      icon: 'w-4 h-4',
      text: 'text-xs',
    },
    sm: {
      box: 'w-5 h-5',
      icon: 'w-5 h-5',
      text: 'text-xs',
    },
    md: {
      box: 'w-6 h-6',
      icon: 'w-6 h-6',
      text: 'text-sm',
    },
    lg: {
      box: 'w-7 h-7',
      icon: 'w-7 h-7',
      text: 'text-sm',
    },
  }[props.size]
})

const updateValue = (value: boolean) => {
  emit('update:modelValue', value)
}
</script>

<template>
    <label class="flex items-center gap-2 cursor-pointer select-none">
        <input :name="name" :value="value" type="checkbox" :checked="modelValue" class="hidden peer"
            @change="updateValue(($event.target as HTMLInputElement).checked)" />

        <div :class="[
            sizeClasses?.box,
            'rounded-lg border flex items-center justify-center duration-200 p-1',
        ]" :style="{
        borderColor: color,
        backgroundColor: modelValue ? color : 'transparent',
    }">
            <svg v-if="modelValue" width="8" height="6" :class="[sizeClasses?.icon, 'text-white']" viewBox="0 0 11 8"
                fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.5 0.75L3.11625 7L0.75 4.58875" stroke="currentColor" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </div>

        <span v-if="label || $slots.default" :class="[sizeClasses?.text, 'ml-2 font-medium']"
            :style="{ color: labelColor }">
            <slot>
                {{ label }}
            </slot>
        </span>
    </label>
</template>